import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";

const types = ["Terrain","Communication","Réseaux sociaux","Photographie","Vidéo","Informatique","Événementiel","Collecte de fonds","Traduction","Administration","Accompagnement de projets","Autre"];

export default function Volunteer() {
  const { t } = useI18n();
  const [f, setF] = useState({ first_name:"", last_name:"", email:"", phone:"", country:"", city:"", skills:"", availability:"", volunteer_type:"Terrain", motivation:"", message:"", consent:false });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!f.consent) { toast.error(t("volunteer.consentErr")); return; }
    setLoading(true);
    try {
      await api.post("/volunteer", f);
      toast.success(t("volunteer.thanks"));
      nav("/merci", { state: { type: "volunteer" } });
    } catch { toast.error(t("volunteer.err")); }
    finally { setLoading(false); }
  };

  const set = (k, v) => setF(s => ({ ...s, [k]: v }));

  return (
    <div data-testid="volunteer-page">
      <section className="hero-gradient py-24">
        <div className="max-w-5xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.volunteer.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.volunteer.t1")}<br/><span className="italic text-warm-orange">{t("pages.volunteer.t2")}</span></h1>
        </div>
      </section>
      <section className="py-16 bg-ivory">
        <form onSubmit={submit} className="max-w-5xl mx-auto px-5 lg:px-10 grid md:grid-cols-2 gap-4">
          <input required placeholder={t("volunteer.firstName")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.first_name} onChange={e=>set("first_name",e.target.value)} data-testid="v-first"/>
          <input required placeholder={t("volunteer.lastName")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.last_name} onChange={e=>set("last_name",e.target.value)} data-testid="v-last"/>
          <input required type="email" placeholder={t("volunteer.email")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.email} onChange={e=>set("email",e.target.value)} data-testid="v-email"/>
          <input placeholder={t("volunteer.phone")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.phone} onChange={e=>set("phone",e.target.value)} data-testid="v-phone"/>
          <input placeholder={t("volunteer.country")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.country} onChange={e=>set("country",e.target.value)} data-testid="v-country"/>
          <input placeholder={t("volunteer.city")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.city} onChange={e=>set("city",e.target.value)} data-testid="v-city"/>
          <input placeholder={t("volunteer.skills")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none md:col-span-2" value={f.skills} onChange={e=>set("skills",e.target.value)} data-testid="v-skills"/>
          <input placeholder={t("volunteer.availability")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.availability} onChange={e=>set("availability",e.target.value)} data-testid="v-avail"/>
          <select className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none bg-white" value={f.volunteer_type} onChange={e=>set("volunteer_type",e.target.value)} data-testid="v-type">
            {types.map(tp=><option key={tp}>{tp}</option>)}
          </select>
          <textarea rows={3} placeholder={t("volunteer.motivation")} className="md:col-span-2 p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.motivation} onChange={e=>set("motivation",e.target.value)} data-testid="v-motiv"/>
          <textarea rows={3} placeholder={t("volunteer.messageLbl")} className="md:col-span-2 p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.message} onChange={e=>set("message",e.target.value)} data-testid="v-message"/>
          <label className="md:col-span-2 flex items-start gap-2 text-sm text-deep-blue/70">
            <input type="checkbox" checked={f.consent} onChange={e=>set("consent",e.target.checked)} data-testid="v-consent"/>
            {t("volunteer.consent")}
          </label>
          <button disabled={loading} className="btn-gold md:col-span-2 py-4 rounded-full font-semibold" data-testid="v-submit">
            {loading? t("volunteer.submitting") : t("volunteer.submit")}
          </button>
        </form>
      </section>
    </div>
  );
}
